import { render, staticRenderFns } from "./CardPersonPlaceholder.vue?vue&type=template&id=5b95e838"
import script from "./CardPersonPlaceholder.vue?vue&type=script&lang=js"
export * from "./CardPersonPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports